import { gql, useQuery } from '@apollo/client';

import type {
  GetAccountRemittanceVariances,
  GetAccountRemittanceVariancesVariables,
  GetAccountRemittanceVariances_getAccountRemittanceVariances_variances_by_account_variances,
} from './__generated__/GetAccountRemittanceVariances';

export const GET_ACCOUNT_REMITTANCE_VARIANCES = gql`
  query GetAccountRemittanceVariances($input: GetAccountRemittanceVariancesInput!) {
    getAccountRemittanceVariances(input: $input) {
      variances_by_account {
        account_id
        variances {
          upload_id
          account_id
          payment_month
          variance_code
          status
          note
          version
          updated_at_milliseconds
        }
      }
    }
  }
`;

export type AccountVariance =
  GetAccountRemittanceVariances_getAccountRemittanceVariances_variances_by_account_variances;

/**
 * Fetch variance items for a page of account IDs within an upload. Returns a map keyed
 * by account_id → variance items (multiple possible per account). Accounts with no
 * detected variances are still present in the response with an empty array.
 *
 * Scope: the datatable (see `RemittanceTapeDealTable`) passes the currently-rendered
 * page of account IDs so only the visible page gets hydrated — avoids the full-upload
 * `getUploadRemittanceVariances` fetch when the seller is just scrolling.
 */
export function useGetAccountRemittanceVariances(
  uploadId: string | undefined,
  accountIds: string[],
) {
  const skip = !uploadId || accountIds.length === 0;
  return useQuery<GetAccountRemittanceVariances, GetAccountRemittanceVariancesVariables>(
    GET_ACCOUNT_REMITTANCE_VARIANCES,
    {
      variables: {
        input: {
          upload_id: uploadId ?? '',
          account_ids: accountIds,
        },
      },
      skip,
      fetchPolicy: 'cache-and-network',
    },
  );
}
